package de.connect2x.timmy.brandings.lifetimeTheme

import androidx.compose.ui.graphics.Color

//Light theme template
internal val md_theme_light_primary = lt_blue
internal val md_theme_light_onPrimary = Color.White
internal val md_theme_light_primaryContainer = lt_light_gray
internal val md_theme_light_onPrimaryContainer = lt_dark_blue
internal val md_theme_light_secondary = lt_accent_blue
internal val md_theme_light_onSecondary = Color.Black
internal val md_theme_light_secondaryContainer = lt_blue
internal val md_theme_light_onSecondaryContainer = Color.White
internal val md_theme_light_tertiary = lt_dark_blue
internal val md_theme_light_onTertiary = lt_light_gray
internal val md_theme_light_tertiaryContainer = lt_blue
internal val md_theme_light_onTertiaryContainer = Color.White
internal val md_theme_light_error = lt_accent_red
internal val md_theme_light_onError = Color.White
internal val md_theme_light_errorContainer = lt_accent_orange
internal val md_theme_light_onErrorContainer = lt_dark_blue
internal val md_theme_light_background = Color.White
internal val md_theme_light_onBackground = lt_dark_blue
internal val md_theme_light_surface = Color.White
internal val md_theme_light_onSurface = lt_dark_blue
internal val md_theme_light_surfaceVariant = lt_light_gray
internal val md_theme_light_onSurfaceVariant = lt_dark_blue
internal val md_theme_light_outline = lt_accent_blue
internal val md_theme_light_outlineVariant = lt_dark_blue
internal val md_theme_light_scrim = Color.Black
internal val md_theme_light_inverseSurface = Color.White
internal val md_theme_light_inverseOnSurface = Color.Red
internal val md_theme_light_inversePrimary = lt_dark_blue

internal val md_theme_light_surfaceDim = Color.White
internal val md_theme_light_surfaceBright = Color.White
internal val md_theme_light_surfaceContainerLowest = Color.White
internal val md_theme_light_surfaceContainerLow = Color.White
internal val md_theme_light_surfaceContainer = Color.White
internal val md_theme_light_surfaceContainerHigh = Color.White
internal val md_theme_light_surfaceContainerHighest = lt_accent_blue


// Dark theme template (mostly used for lightness/saturation)
internal val md_theme_dark_primary = lt_light_blue
internal val md_theme_dark_onPrimary = Color.Black
internal val md_theme_dark_primaryContainer = lt_dark_blue
internal val md_theme_dark_onPrimaryContainer = Color.White
internal val md_theme_dark_secondary = lt_dark_gray
internal val md_theme_dark_onSecondary = Color.White
internal val md_theme_dark_secondaryContainer = lt_blue
internal val md_theme_dark_onSecondaryContainer = Color.White
internal val md_theme_dark_tertiary = lt_light_gray
internal val md_theme_dark_onTertiary = Color.Black
internal val md_theme_dark_tertiaryContainer = lt_blue
internal val md_theme_dark_onTertiaryContainer = Color.White
internal val md_theme_dark_error = lt_accent_red
internal val md_theme_dark_errorContainer = lt_accent_orange
internal val md_theme_dark_onError = Color.White
internal val md_theme_dark_onErrorContainer = Color.Black
internal val md_theme_dark_background = lt_dark_gray
internal val md_theme_dark_onBackground = Color.White
internal val md_theme_dark_surface = lt_dark_gray
internal val md_theme_dark_onSurface = Color.White
internal val md_theme_dark_surfaceVariant = lt_light_gray
internal val md_theme_dark_onSurfaceVariant = Color.White
internal val md_theme_dark_outline = lt_accent_blue
internal val md_theme_dark_inverseSurface = Color.White   // FIXME
internal val md_theme_dark_inverseOnSurface = lt_dark_gray
internal val md_theme_dark_inversePrimary = lt_blue    // FIXME
internal val md_theme_dark_outlineVariant = lt_accent_cyan   // FIXME
internal val md_theme_dark_scrim = Color.Black

internal val md_theme_dark_surfaceDim = Color.Black
internal val md_theme_dark_surfaceBright = lt_medium_gray
internal val md_theme_dark_surfaceContainerLowest = Color.Black
internal val md_theme_dark_surfaceContainerLow = lt_dark_gray
internal val md_theme_dark_surfaceContainer = lt_dark_gray
internal val md_theme_dark_surfaceContainerHigh = lt_dark_gray
internal val md_theme_dark_surfaceContainerHighest = lt_medium_gray

//messenger colors light theme
internal val messenger_theme_light_success = lt_accent_cyan
internal val messenger_theme_light_warning = lt_accent_orange
internal val messenger_theme_light_error = lt_accent_red
internal val messenger_theme_light_neutral = lt_light_gray
internal val messenger_theme_light_preview_content = Color.White.copy(alpha = 0.7f)
internal val messenger_theme_light_preview_scrim = Color.Black.copy(alpha = 0.7f)
internal val messenger_theme_light_link_other = lt_dark_blue
internal val messenger_theme_light_link_own = lt_dark_blue
internal val messenger_theme_light_users = listOf(lt_dark_blue)
/* //Default rotating colors for users
internal val messenger_theme_light_users = listOf(
    Color(0xFFA41515),
    Color(0xFFA46715),
    Color(0xFF908213),
    Color(0xFF139057),
    Color(0xFF138190),
    Color(0xFF135F90),
    Color(0xFF132F90),
    Color(0xFF3F1390),
    Color(0xFF6E1390),
    Color(0xFF901355)
)
*/

internal val messenger_theme_dark_success = lt_accent_cyan
internal val messenger_theme_dark_warning = lt_accent_orange
internal val messenger_theme_dark_error = lt_accent_red
internal val messenger_theme_dark_neutral = lt_light_gray
internal val messenger_theme_dark_preview_content = Color.White.copy(alpha = 0.7f)
internal val messenger_theme_dark_preview_scrim = Color.Black.copy(alpha = 0.7f)
internal val messenger_theme_dark_link_other = lt_dark_blue
internal val messenger_theme_dark_link_own = lt_dark_blue
internal val messenger_theme_dark_users = listOf(lt_dark_blue)
/*
//Default rotating colors for users
internal val messenger_theme_dark_users = listOf(
   Color(0xFFe61c1c),
   Color(0xFFdb8818),
   Color(0xFFd6c11c),
   Color(0xFF1cd480),
   Color(0xFF18b6cc),
   Color(0xFF1b8ad1),
   Color(0xFF4767d6),
   Color(0xFF753cde),
   Color(0xFFa424d4),
   Color(0xFFe61e87)
)
*/

